export default __webpack_public_path__ + "static/media/GruenLemonograf.74f392a7.ttf";